import { ApiProperty } from '@nestjs/swagger';
import { ArrayMinSize, ArrayNotEmpty, IsArray, IsEnum, IsNotEmpty, IsObject, IsOptional, IsString } from 'class-validator';
import { BlockField, BlockTemplate, BlockType } from './const';

export class Block {
  @ApiProperty()
  id: number;

  @ApiProperty()
  name?: string | null;

  @ApiProperty()
  props: Record<string, unknown>;

  @ApiProperty({
    enum: BlockType,
    default: BlockType.route,
  })
  type: BlockType;

  @ApiProperty()
  entityId?: string | null;

  @ApiProperty({
    enum: BlockTemplate,
  })
  template: BlockTemplate;
}

export class IdBlocksRequest {
  @ApiProperty({
    description: 'Массив id блоков',
    type: [Number],
    example: [1, 2],
    minItems: 1,
  })
  @IsArray({ message: 'Поле names должно быть массивом' })
  @ArrayNotEmpty({ message: 'Массив ids не должен быть пустым' })
  @ArrayMinSize(1, { message: 'Массив ids должен содержать хотя бы один элемент' })
  ids: number[];
}

export class BlockRequest {
  @ApiProperty()
  @IsNotEmpty()
  @IsObject()
  props: Record<string, unknown>;

  @ApiProperty({
    enum: BlockTemplate,
  })
  @IsNotEmpty()
  @IsEnum(BlockTemplate)
  template: BlockTemplate;
}

export class BlockRequestWithName {
  @ApiProperty()
  @IsOptional()
  @IsString()
  name?: string;

  @ApiProperty()
  @IsNotEmpty()
  @IsObject()
  props: Record<string, unknown>;

  @ApiProperty({
    enum: BlockTemplate,
  })
  @IsNotEmpty()
  @IsEnum(BlockTemplate)
  template: BlockTemplate;
}

export class BlockRouteRequest {
  routeId: string;
}

export class BlockNameRequest {
  name: string;
}

export class BlockNamesRequest {
  names?: string[];
}

export class BlockIdRequest {
  id: number;
}

export type BlockBase<K, T extends string> = Record<BlockTemplate, Record<T, K>>;

export type BlockConfig = BlockBase<
  {
    field: BlockField;
    default?: unknown;
  },
  string
>;

export interface ReferenceProps {
  id: number;
  shortcodes: Record<string, unknown>;
}

export class ClientRouteBlock {
  block: Block;
  innerBlocks?: ClientRouteBlock[];
}
